export const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const formatTime = (isoString) => {
  if (!isoString) return '-';
  const date = new Date(isoString);
  return date.toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' });
};

export const formatMinutes = (minutes) => {
  if (!minutes && minutes !== 0) return '-';
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  const decimal = (minutes / 60).toFixed(2);
  return `${hours}:${mins.toString().padStart(2, '0')} (${decimal})`;
};

export const formatEmployeeName = (employee) => {
  const displayMode = employee.display_mode || 1;
  const firstName = employee.first_name || '';
  const lastName = employee.last_name || '';
  const employeeNumber = employee.employee_number || '';
  const displayName = employee.display_name || '';

  switch (displayMode) {
    case 1:
      // Backend liefert bei Namens-Kollisionen bereits "Vorname Nachname (EMP-123)"
      if (displayName && displayName.includes('(')) return displayName;
      return employeeNumber
        ? `${firstName} ${lastName} (${employeeNumber})`
        : `${firstName} ${lastName}`;
    case 2:
      return employeeNumber
        ? `${displayName} (${employeeNumber})`
        : displayName;
    case 3:
      return displayName;
    case 4:
      return employeeNumber || '-';
    case 5:
      // Backend macht Kollisions-Check (1 Buchstabe → 2 Buchstaben → +EMP-Nr).
      if (displayName) return displayName;
      return firstName
        ? `${firstName.charAt(0)}. ${lastName}`
        : lastName;
    default:
      return `${firstName} ${lastName}`;
  }
};
